// Operating-hours helpers — canonical implementation lives in
// @vertu/shared/booking-core (parity Phase 0.5). This module keeps the
// historical import path and binds the widget's own Supabase client into
// loadServiceHours so call sites keep their one-argument signature.

import { useEffect, useState } from "react";
import { supabase } from "../config";
import {
  loadServiceHours as sharedLoadServiceHours,
  type ServiceHoursRow,
} from "@vertu/shared";

export {
  windowsForDate,
  inputBoundsForDate,
  hoursPillText,
  openWindowsMsForDate,
  isWithinServiceHours,
  type ServiceHoursRow,
} from "@vertu/shared";

export function loadServiceHours(serviceId: string) {
  return sharedLoadServiceHours(supabase, serviceId);
}

// Service operating hours, loaded once on mount per service. Empty array = no
// constraint (server-side check is fail-open too). Moved from ServicePanel.tsx
// with zero behaviour change.
export function useServiceHours(serviceId: string): ServiceHoursRow[] {
  const [serviceHours, setServiceHours] = useState<ServiceHoursRow[]>([]);
  useEffect(() => {
    let cancelled = false;
    loadServiceHours(serviceId).then((rows) => {
      if (!cancelled) setServiceHours(rows);
    });
    return () => {
      cancelled = true;
    };
  }, [serviceId]);
  return serviceHours;
}
